const FOUR = 4;
const BUSINESS_ID_PREFIX_LENGTH = 2;
const BUSINESS_ID_DIGIT_LIMIT = 9;
const BUSINESS_ID_FIRST_DIGIT_INDEX = 0;

export const formatBusinessIdentificationNumber = (value: string) => {
    const digits = value.replace(/\D/g, '');
    if (digits.length <= BUSINESS_ID_PREFIX_LENGTH) return digits;
    return `${digits.slice(
        BUSINESS_ID_FIRST_DIGIT_INDEX,
        BUSINESS_ID_PREFIX_LENGTH,
    )}-${digits.slice(BUSINESS_ID_PREFIX_LENGTH, BUSINESS_ID_DIGIT_LIMIT)}`;
};

const NINE_NINE = 99;
const CERO = 0;
const NINE_NINE_NINE = 999999.99;
const NINE_NINE_NINE_NINE = 999999999.99;
const GROSS_INCOME_MAX = 999999.99;
const LENGTH_NUMBER = 30;
export const ADDRESS_NUMBER = 40;
export const ADDRESS_NUMBER2 = 25;
export const OCCUPATION_LENGTH = 20;
//const YEAR = 1927;
export const validateRangeFourToNineNine = (value: number) => {
    return !(value >= FOUR && value <= NINE_NINE);
};

export const validateRangeToTradeAmount = (value: number) => {
    return !(value >= -NINE_NINE_NINE && value <= NINE_NINE_NINE);
};

export const validateRangeCeroToNineNine = (value: number) => {
    return !(value >= CERO && value <= NINE_NINE_NINE);
};

export const validateRangeCeroToNineNineNine = (value: number) => {
    return !(value >= CERO && value <= NINE_NINE_NINE_NINE);
};

export const validateGrossIncomeAmount = (value: number) => {
    return !Number.isFinite(value) || value <= CERO || value > GROSS_INCOME_MAX;
};

export const validateLengthNumber = (
    value: string | null,
    validation: number = LENGTH_NUMBER,
) => {
    if (value) return !(value && value.length <= validation);
    return false;
};

export const validateRequired = (value: string | number | null) => {
    if (value === null || value === undefined || value === '') return true;
    return false;
};

export const validateCarYear = (value: number) => {
    const year = new Date().getFullYear();
    return !(year - Number('50') <= value && value <= year + Number('1'));
};

export const removeLeadingZeros = (input: string) => {
    return +Number(input).toString();
};

export const validateJobYear = (value: number) => {
    return !(value >= Number('0') && value <= Number('99'));
};

export const validateJobMonth = (value: number) => {
    return !(value >= Number('0') && value <= Number('11'));
};

export const validateOccupation = (value: string) => {
    return new RegExp(/^[a-zA-Z0-9_\s.]{1,20}$/).test(value);
};

export const validateZipCanada = (value: string) => {
    if (
        new RegExp(
            /^[ABCEGHJ-NPRSTVXY][0-9][ABCEGHJ-NPRSTV-Z][ -]?[0-9][ABCEGHJ-NPRSTV-Z][0-9]$/i,
        ).test(value)
    ) {
        return false;
    }
    return true;
};

export const validateZipUSA = (value: string) => {
    const [first, second] = value.split('-');

    if (
        new RegExp(/(?!00000)(^[0-9]{5,5}$)/).test(first) ||
        new RegExp(/^[0-9]{4,4}$/).test(second)
    )
        return false;
    return true;
};

export const getStateOptions = (
    isCanada: boolean,
    occupationIndividualInformation: any,
) => {
    let states = [];
    if (isCanada) {
        states = [
            {
                value: 'AB',
                label: occupationIndividualInformation.PROVINCES_AB,
            },
            {
                value: 'BC',
                label: occupationIndividualInformation.PROVINCES_BC,
            },
            {
                value: 'MB',
                label: occupationIndividualInformation.PROVINCES_MB,
            },
            {
                value: 'NB',
                label: occupationIndividualInformation.PROVINCES_NB,
            },
            {
                value: 'NL',
                label: occupationIndividualInformation.PROVINCES_NL,
            },
            {
                value: 'NS',
                label: occupationIndividualInformation.PROVINCES_NS,
            },
            {
                value: 'NT',
                label: occupationIndividualInformation.PROVINCES_NT,
            },
            {
                value: 'NU',
                label: occupationIndividualInformation.PROVINCES_NU,
            },
            {
                value: 'ON',
                label: occupationIndividualInformation.PROVINCES_ON,
            },
            {
                value: 'PE',
                label: occupationIndividualInformation.PROVINCES_PE,
            },
            {
                value: 'QC',
                label: occupationIndividualInformation.PROVINCES_QC,
            },
            {
                value: 'SK',
                label: occupationIndividualInformation.PROVINCES_SK,
            },
            {
                value: 'YT',
                label: occupationIndividualInformation.PROVINCES_YT,
            },
        ];
    } else {
        states = [
            { value: 'AK', label: 'AK' },
            { value: 'AL', label: 'AL' },
            { value: 'AR', label: 'AR' },
            { value: 'AZ', label: 'AZ' },
            { value: 'CA', label: 'CA' },
            { value: 'CO', label: 'CO' },
            { value: 'CT', label: 'CT' },
            { value: 'DC', label: 'DC' },
            { value: 'DE', label: 'DE' },
            { value: 'FL', label: 'FL' },
            { value: 'GA', label: 'GA' },
            { value: 'HI', label: 'HI' },
            { value: 'IA', label: 'IA' },
            { value: 'ID', label: 'ID' },
            { value: 'IL', label: 'IL' },
            { value: 'IN', label: 'IN' },
            { value: 'KS', label: 'KS' },
            { value: 'KY', label: 'KY' },
            { value: 'LA', label: 'LA' },
            { value: 'MA', label: 'MA' },
            { value: 'MD', label: 'MD' },
            { value: 'ME', label: 'ME' },
            { value: 'MI', label: 'MI' },
            { value: 'MN', label: 'MN' },
            { value: 'MO', label: 'MO' },
            { value: 'MS', label: 'MS' },
            { value: 'MT', label: 'MT' },
            { value: 'NC', label: 'NC' },
            { value: 'ND', label: 'ND' },
            { value: 'NE', label: 'NE' },
            { value: 'NH', label: 'NH' },
            { value: 'NJ', label: 'NJ' },
            { value: 'NM', label: 'NM' },
            { value: 'NV', label: 'NV' },
            { value: 'NY', label: 'NY' },
            { value: 'OH', label: 'OH' },
            { value: 'OK', label: 'OK' },
            { value: 'OR', label: 'OR' },
            { value: 'PA', label: 'PA' },
            { value: 'RI', label: 'RI' },
            { value: 'SC', label: 'SC' },
            { value: 'SD', label: 'SD' },
            { value: 'TN', label: 'TN' },
            { value: 'TX', label: 'TX' },
            { value: 'UT', label: 'UT' },
            { value: 'VA', label: 'VA' },
            { value: 'VT', label: 'VT' },
            { value: 'WA', label: 'WA' },
            { value: 'WI', label: 'WI' },
            { value: 'WV', label: 'WV' },
            { value: 'WY', label: 'WY' },
        ];
    }
    return states;
};

export const validateMI = (value: string) => {
    return /[A-Za-z _.,!"'$]+/.test(value);
};

export const validateOwnership = (value: string) => {
    return +value >= Number('0') && +value <= Number('100');
};

export const getTitleOptions = (businessComercial: any) => {
    return [
        {
            value: 'O',
            label: businessComercial.DRIVER_OPTION_OWNER,
        },
        {
            value: 'P',
            label: businessComercial.DRIVER_OPTION_PRESIDENT,
        },
        {
            value: 'VP',
            label: businessComercial.DRIVER_OPTION_VICEPRESIDENT,
        },
        {
            value: 'T',
            label: businessComercial.DRIVER_OPTION_TREASURER,
        },
        {
            value: 'UK',
            label: businessComercial.DRIVER_OPTION_OTHER,
        },
    ];
};

export const validatePhone = (value: any) => {
    let aux: string = value
        .split('(')
        .join()
        .split(')')
        .join()
        .split('-')
        .join();
    aux = aux.replaceAll(',', '').replaceAll(' ', '');
    if (
        new RegExp(/(\(\d{3}\)\s\d{3}-\d{4})?$/).test(value) &&
        aux.length === Number('10') &&
        !/^(?!000-000-000)(?!111-111-111)(?!222-222-222)(?!333-333-333)(?!444-444-444)(?!555-555-555)(?!666-666-666)(?!777-777-777)(?!888-888-888)(?!123-456-789)(\d{3}-\d{3}-\d{3})$/i.test(
            value,
        )
    ) {
        return true;
    }
    return false;
};

export const validateCompanyName = (name: string) => {
    if (/^[a-zA-ZÀ-ÿ0-9 &.,'’()\-\\/+#<>\[\]\|\^=\*@]{1,50}$/.test(name)) {
        return true;
    } else return false;
};

export const validateBusinessName = (name: string) => {
    if (/^[a-zA-ZÀ-ÿ0-9 &.,'’\-\\/+#<>\[\]\|\^=\*@]{1,50}$/.test(name)) {
        return true;
    } else return false;
};

export const validateBirth = (value: any) => {
    if (typeof value !== 'string') return false;

    const m = /^(\d{2})\/(\d{2})\/((?:19|20)\d{2})$/.exec(value.trim());
    if (!m) return false;

    const THIRTY = 30;
    const THIRTY_ONE = 31;
    const TWENTY_EIGHT = 28;

    const month = Number(m[1]);
    const day = Number(m[2]);
    const year = Number(m[3]);

    if (month < Number('1') || month > Number('12')) return false;

    const daysInMonth = [
        THIRTY_ONE,
        TWENTY_EIGHT,
        THIRTY_ONE,
        THIRTY,
        THIRTY_ONE,
        THIRTY,
        THIRTY_ONE,
        THIRTY_ONE,
        THIRTY,
        THIRTY_ONE,
        THIRTY,
        THIRTY_ONE,
    ];
    const isLeap =
        year % Number('400') === Number('0') ||
        (year % Number('4') === Number('0') &&
            year % Number('100') !== Number('0'));
    if (isLeap) daysInMonth[1] = 29;

    if (day >= Number('1') && day <= daysInMonth[month - Number('1')]) {
        return true;
    }
    return false;
};

export type ModelEntry = {
    model: string;
    bodyTypes: string[];
};

export type YearEntry = {
    year: string;
    models: ModelEntry[];
};

export const getCurrentYear = (
    localYears: YearEntry[],
    localVehicleYear: string,
) => {
    return (
        localYears.find((ele: YearEntry) => ele.year === localVehicleYear) ||
        null
    );
};

export const getCurrentModel = (
    currentYear: YearEntry,
    vehicleModelString: string,
) => {
    return (
        currentYear?.models?.find(
            (ele: ModelEntry) => ele.model === vehicleModelString,
        ) || null
    );
};

export const getCurrentBodyType = (
    currentModel: ModelEntry,
    localBodyType: string,
) => {
    return (
        currentModel?.bodyTypes?.find((ele: string) => ele === localBodyType) ||
        null
    );
};

export const getSelectedBodyType = (
    shouldSetInitial: boolean,
    currentModel: ModelEntry,
    localBodyType: string,
) => {
    return shouldSetInitial &&
        currentModel &&
        currentModel?.bodyTypes?.includes(localBodyType || '')
        ? localBodyType
        : '';
};
